import React from "react";
import { Modal } from "react-bootstrap";
import RentalStatus from "../../enums/RentalStatus";
import "../../css/rentals/rentals.css";

class RentalDeleteModal extends React.Component {
  render() {
    const {
      show,
      rental,
      deletionReason,
      isLoading,
      onClose,
      onReasonChange,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = (rental.product && rental.product.designation)
      ? rental.product.designation
      : (rental.product_name || "Produit");
    const isEnAttente = rental.status === RentalStatus.EN_ATTENTE;
    const isReasonValid = deletionReason && deletionReason.trim().length > 0;

    // Pour les statuts autres que EN_ATTENTE, pas besoin de raison
    const canConfirm = isEnAttente ? isReasonValid : true;

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-cancel-modal"
      >
        <Modal.Header className="rental-delete-modal-header">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-trash mr-2"></i>
            Suppression de location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Confirmer la suppression
            </h5>
            <p className="rental-modal-form-hint">
              {isEnAttente
                ? "Vous êtes sur le point de supprimer définitivement la location pour :"
                : "Êtes-vous sûr de vouloir supprimer définitivement cette location ?"}
            </p>
            {isEnAttente && (
              <div className="rental-modal-product-section">
                <strong className="rental-modal-product-name">
                  {productName}
                </strong>
              </div>
            )}
          </div>

          {isEnAttente && (
            <div className="rental-modal-form-group">
              <label
                htmlFor="deletionReason"
                className="rental-modal-form-label rental-modal-form-label-required"
              >
                Raison de la suppression
              </label>
              <textarea
                id="deletionReason"
                className="rental-modal-form-textarea"
                rows="4"
                placeholder="Expliquez la raison de la suppression (obligatoire)..."
                value={deletionReason}
                onChange={onReasonChange}
                required
                disabled={isLoading}
                maxLength={500}
              />
              <small className="rental-modal-form-hint-small">
                {deletionReason.length}/500 caractères{" "}
                {!isReasonValid && (
                  <span className="rental-modal-form-label-required">
                    (obligatoire)
                  </span>
                )}
              </small>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading || !canConfirm}
            className={`rental-modal-btn-primary ${
              isLoading || !canConfirm
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Suppression...</span>
              </>
            ) : (
              <>Confirmer la suppression</>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalDeleteModal;
